<template>
    <div>
        <h2 id="relatedproducts">Похожие товары</h2>
        <div class="uk-grid-medium uk-grid-match uk-child-width-1-4@m uk-child-width-1-3@s"
             uk-grid>

            <product v-for="Product in ShopItems" :key="Product.ShopItem.id"
                     :shop-item="Product.ShopItem"
                     :image="Product.Asset"
                     :shop-product="Product.ShopProduct"
                     :shop-item-prices="ShopItemPrices[Product.ShopItem.id]"
                     :shop-item-properties="ShopItemProperties[Product.ShopItem.id]"

            ></product>

        </div>
    </div>
</template>

<script>
    import Product from './Product'
    export default {
        name: "RelatedProducts",
        components: {
            Product
        },
        props: {
            ShopItems: {
                type: Array,
                required: true
            },

            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },

            ShopItemProperties: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RelatedProducts.vue?14c4d02c